import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";

import { FavoriteIconComponent } from "./components/favorite-icon/favorite-icon.component";

@NgModule({
    declarations: [
        FavoriteIconComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule
    ],
    exports: [
        FavoriteIconComponent,
        CommonModule
    ]
})

export class SharedModule {}